<template>
  <el-card shadow="hover" :style="{ borderLeft: `4px solid ${color}` }" class="summary-card-container">
    <div class="summary-card">
      <div class="icon-container" :style="{ backgroundColor: color + '20' }">
        <i :class="icon" :style="{ color }"></i>
      </div>
      <div class="content">
        <div class="title">{{ title }}</div>

        <div class="value">
          <count-to
              v-if="animate"
              :key="valueKey"
              :end-val="numericValue"
              :duration="1500"
              :decimals="isMoney ? 2 : 0"
          />
          <span v-else>{{ formattedValue }}</span>
          <span class="unit">{{ unit }}</span>
        </div>

        <!-- 对比数据展示 -->
        <div v-if="showCompare" class="compare-container">
          <div class="compare-header">
            <span class="compare-time" v-if="compareLabel">{{ compareLabel }}</span>
            <span class="compare-value">
              <span class="compare-label">对比值:</span>
              <span>{{ formattedCompareValue }} {{ unit }}</span>

            </span>
          </div>
          <div class="compare-trend" :class="trendClass">
            <i :class="trendIcon"></i>
            <span>{{ trendText }}</span>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import CountTo from 'vue-count-to'

export default {
  name: 'SummaryCard',
  components: {
    CountTo
  },
  props: {
    title: String,
    value: [Number, String],
    compareValue: [Number, String],
    compareLabel: String, // 新增：对比时间，如 “2024年7月”
    unit: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'el-icon-star-on'
    },
    color: {
      type: String,
      default: '#409EFF'
    },
    animate: {
      type: Boolean,
      default: true
    },
    showCompare: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    numericValue() {
      return Number(this.value) || 0
    },
    numericCompareValue() {
      return Number(this.compareValue) || 0
    },
    isMoney() {
      return ['总销售额', '平均单价'].includes(this.title)
    },
    valueKey() {
      return `${this.title}-${this.value}`
    },
    formattedValue() {
      return this.isMoney
          ? this.numericValue.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : this.numericValue.toLocaleString()
    },
    formattedCompareValue() {
      return this.isMoney
          ? this.numericCompareValue.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : this.numericCompareValue.toLocaleString()
    },
    trendClass() {
      if (this.numericCompareValue === 0 || this.compareValue === null) return 'trend-neutral'
      return this.numericValue >= this.numericCompareValue ? 'trend-up' : 'trend-down'
    },
    trendIcon() {
      if (this.numericCompareValue === 0 || this.compareValue === null) return 'el-icon-minus'
      return this.numericValue >= this.numericCompareValue ? 'el-icon-top' : 'el-icon-bottom'
    },
    trendText() {
      if (this.numericCompareValue === 0 || this.compareValue === null) return '无对比数据'
      const diff = this.numericValue - this.numericCompareValue
      const percentage = (Math.abs(diff) / this.numericCompareValue * 100).toFixed(2)
      return `${diff >= 0 ? '+' : '-'}${percentage}%（${diff >= 0 ? '+' : ''}${diff.toLocaleString()}）`
    }
  }
}
</script>

<style scoped>
.summary-card-container {
  height: 100%;
}

.summary-card {
  display: flex;
  align-items: center;
  min-height: 80px;
}

.icon-container {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.icon-container i {
  font-size: 24px;
}

.content {
  flex: 1;
}

.title {
  font-size: 14px;
  color: #909399;
  margin-bottom: 5px;
}

.value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  display: flex;
  align-items: baseline;
}

.unit {
  font-size: 14px;
  margin-left: 4px;
  color: #909399;
}

.compare-container {
  margin-top: 8px;
  font-size: 12px;
  color: #606266;
}

.compare-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}

.compare-time {
  font-weight: bold;
  color: #909399;
}

.compare-value {
  display: flex;
  align-items: center;
}

.compare-label {
  margin-right: 6px;
  color: #909399;
}

.compare-trend {
  display: flex;
  align-items: center;
}

.compare-trend i {
  margin-right: 4px;
}

.trend-up {
  color: #67C23A;
}

.trend-down {
  color: #F56C6C;
}

.trend-neutral {
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// SummaryCard.vue?9929d97e